import {
    CCard,
    CCardBody,
    CCardGroup,
    CForm,
    CCol,
    CFormInput,
    CFormLabel,
    CRow,
    CFormSelect,
    CFormCheck,
    CSpinner
} from '@coreui/react';
import React, { Component } from 'react';
import AppButton from 'src/components/AppButton'
import {
    cilCheck,
    cilSave,
    cilTrash
} from '@coreui/icons'
import ServerConnector from 'src/ServerConnector'
import PageHeader from 'src/components/PageHeader'

class AddMessageGroup extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            set_seq: this.props.page_data.set_seq,
            pageNamePrefix: this.props.page_data.set_seq == -999 ? "Add" : "Edit",
            inputs: {
                name: "",
                nameerr: "",
                isPublic: false
            },
            allStudentList: [],
            studentDropDownSpinner: false,
            selectedStudent: -1,
            selectedStudentError: "",
            studentForSet: [],
            studentExcludeFromDropdown: []
        }

        this.classList = ["Public", "Private"];
    }

    componentDidMount() {
        if (this.state.set_seq != -999) {

            this.loadData();
            this.loadSetStudentData();
        }

        this.loadStudentData();
    }

    loadData() {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_STUDENT_SET_DETAILS",
            "set_seq": this.state.set_seq
        }

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            let inputs = this.state.inputs;
            inputs["name"] = data.data[0].set_name;
            inputs["isPublic"] = data.data[0].is_public == "YES";
            this.setState({
                inputs: inputs
            })
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);

            this.props.showAlert("Error", msg, "Ok", null, () => {
                this.props.navigate("student_sets")
            })
        })
    }

    loadStudentData() {
        this.setState({
            studentDropDownSpinner: true,
        });
        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "GET_ALL_STUDENTS"
        }

        connector.postData(dataMap, (data) => { // success

            var activeStudents = [];
            for (var i=0;i<data.data.length;i++) {
                if (data.data[i].status == "ACTIVE") {
                    activeStudents.push(data.data[i]);
                }
            }

            this.setState({
                studentDropDownSpinner: false,
                allStudentList: activeStudents
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                studentDropDownSpinner: false,
                allStudentList: []
            });
        })
    }

    updateInput(inputName, value) {

        let inputs = this.state.inputs;
        inputs[inputName] = value;
        inputs[inputName + "err"] = "";
        this.setState({
            inputs: inputs
        });
    }

    validateForm() {

        var isValid = true;
        let inputs = this.state.inputs;

        if (inputs.name.length == 0) {
            inputs["nameerr"] = "Required";
            isValid = false;
        }

        if (!isValid) {
            this.setState({ inputs: inputs });
        }
        else {
            this.props.showConfirmation(
                "Confirmation",
                "Do you want to save this Message Group?",
                "Yes",
                "No",
                null,
                () => { this.submitForm() }
            );
        }
    }

    submitForm() {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        var dataMap = {
            _action_code: "CREATE_STUDENT_SET",
            set_name: this.state.inputs.name,
            is_public: this.state.inputs.isPublic ? "YES" : "NO",
        };

        if (this.state.set_seq != -999) {
            dataMap["_action_code"] = "UPDATE_STUDENT_SET";
            dataMap["set_seq"] = this.state.set_seq;
        }
        
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            if (this.state.set_seq == -999) {
                this.setState({set_seq: data.data.set_seq});
            }

            this.props.showAlert("Success", data.msg, "Ok", null, () => {
                
            });

        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);

            if (data && data.data) {

                let inputs = this.state.inputs;

                for (let key in data.data) {

                    inputs[key + "err"] = data.data[key];
                }

                this.setState({
                    inputs: inputs
                });
                return;
            }

            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    validateStudentAdd() {

        if (this.state.selectedStudent == -1) {

            this.setState({selectedStudentError: "Required"});
            return;
        }

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        var dataMap = {
            _action_code: "ADD_STUDENTS_TO_SET",
            set_seq: this.state.set_seq,
            student_seq: this.state.selectedStudent,
        };

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);
            this.onStudentSelection(-1);
            this.loadSetStudentData();

        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);

            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    onStudentSelection(studentSeq) {
        this.setState({selectedStudent: studentSeq, selectedStudentError: ""});
    }

    loadSetStudentData() {

        this.props.showPageSpinner(true);
        
        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "GET_ALL_STUDENTS_SET",
            set_seq: this.state.set_seq
        }

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            var studentExcludeFromDropdown = [];
            for (var i=0;i<data.data.length;i++) {
                studentExcludeFromDropdown.push(data.data[i].student_seq);
            }

            this.setState({
                studentForSet: data.data,
                studentExcludeFromDropdown: studentExcludeFromDropdown
            });
        }, (err_cd, msg, data) => { // failure
            this.props.showPageSpinner(false);
            this.setState({
                studentForSet: [],
                studentExcludeFromDropdown: []
            });
        })
    }

    removeStudent(studentSeq) {

        this.props.showPageSpinner(true);
        
        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "REMOVE_STUDENTS_FROM_SET",
            set_seq: this.state.set_seq,
            student_seq: studentSeq
        }
        connector.postData(dataMap, (data) => { // success
            this.props.showPageSpinner(false);
            this.loadSetStudentData();
        }, (err_cd, msg, data) => { // failure
            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    render() {
        return (
            <>
                <PageHeader
                    page_name={this.state.pageNamePrefix + " " + this.props.page_name}
                    onBackPressed={() => this.props.navigate("student_sets")} />
                <CCardGroup>
                    <CCard className="p-4">
                        <CCardBody>
                            <CForm className="row g-3">
                                <CCol md={6}>
                                    <CFormLabel htmlFor="studentName">Group Name *</CFormLabel>
                                    <CFormInput type="text" id="groupName" maxLength="256"
                                        onChange={(event) => { this.updateInput("name", event.target.value) }}
                                        value={this.state.inputs.name} />
                                    <div className="inputError">
                                        {this.state.inputs.nameerr}
                                    </div>
                                </CCol>
                                <CCol md={6}>
                                    <CFormLabel htmlFor="studentClass">Is Public? *</CFormLabel>
                                    <div>
                                        <CFormCheck 
                                            type="radio" 
                                            inline 
                                            name="public" 
                                            id="publicYes" 
                                            label="Yes" 
                                            checked={this.state.inputs.isPublic}
                                            onChange={(event) => this.updateInput("isPublic", event.target.checked)}/>
                                        <CFormCheck 
                                            type="radio" 
                                            inline 
                                            name="public" 
                                            id="publicNo" 
                                            label="No" 
                                            checked={!this.state.inputs.isPublic}
                                            onChange={(event) => this.updateInput("isPublic", !event.target.checked)}/>
                                    </div>
                                    <div className="inputError">
                                        {this.state.inputs.classerr}
                                    </div>
                                </CCol>
                                <CRow className="mt-4">
                                    <CCol xs={12} className="alignCenter">
                                        <AppButton
                                            size="md"
                                            name="Submit"
                                            color="primary"
                                            icon={cilSave}
                                            isLoading={false}
                                            onClick={() => this.validateForm()}>
                                            Submit
                                        </AppButton>
                                    </CCol>
                                </CRow>
                                    {
                                        this.state.set_seq != -999 ?
                                            <>
                                                <CRow className="mt-4">
                                                    <CCol md="4">
                                                        {
                                                            this.state.studentDropDownSpinner ? <CSpinner color="primary" size="sm" className="inlineBlock"/> : null
                                                        }
                                                        <CFormSelect 
                                                            size="sm"
                                                            value={this.state.selectedStudent} 
                                                            onChange={(event) => { this.onStudentSelection(event.target.value) }}
                                                            disabled={this.state.studentDropDownSpinner}
                                                            className="inlineBlock"
                                                            style={{width: '90%'}}>
                                                            <option value={-1}>Select Student</option>
                                                            {
                                                                this.state.allStudentList.map((object, index) => {

                                                                    if (this.state.studentExcludeFromDropdown.indexOf(object.user_seq) > -1) {
                                                                        return null;
                                                                    }
                                                                    return (
                                                                        <option key={String(object.user_seq)} value={object.user_seq}>
                                                                            {object.name}
                                                                        </option>
                                                                    )
                                                                })
                                                            }
                                                        </CFormSelect>
                                                        <div className="inputError">
                                                            {this.state.selectedStudentError}
                                                        </div>
                                                    </CCol>
                                                    <CCol md="1">
                                                        <AppButton
                                                            size="sm"
                                                            name=""
                                                            color="primary"
                                                            icon={cilCheck}
                                                            isLoading={false}
                                                            onClick={() => this.validateStudentAdd()} />
                                                    </CCol>
                                                    <CCol md="7"></CCol>
                                                </CRow>
                                                {
                                                    this.state.studentForSet.map((object, index) => {

                                                        return(
                                                            <CRow className="mt-4" key={object.student_seq+"_"+index}>
                                                                <CCol md="4">
                                                                    {object.name}
                                                                </CCol>
                                                                <CCol md="4">
                                                                    <AppButton
                                                                        size="sm"
                                                                        name=""
                                                                        color="danger"
                                                                        icon={cilTrash}
                                                                        isLoading={false}
                                                                        onClick={() => this.removeStudent(object.student_seq)} />
                                                                </CCol>
                                                                <CCol md="4"></CCol>
                                                            </CRow>
                                                        );
                                                    })
                                                }
                                            </>
                                        : null
                                    }
                            </CForm>
                        </CCardBody>
                    </CCard>
                </CCardGroup>
            </>
        );
    }
}

export default AddMessageGroup;